import React, { useEffect, useState } from "react";
import SmileyRating from "../smileyrating/smileyrating";
import FeedbackTags from "../feedbacktags/feedbacktags";

import styles from "./feedback.module.css";
// import { AppDispatch } from "../../store/store";
import {  RootState } from "../../store/store";
import { Button } from "@walmart-web/livingdesign-components";
import { useSelector } from "react-redux";
// import { useDispatch } from "react-redux";
// import { logQueryFeedback } from "../../store/reducers/logthunks";
import { feedbackTags } from "../../store/constants";
import AdditionalFeedback from "../additionalfeedback/additionalfeedback";

const Feedback = () => {
  const [selectedTags, setSelectedTags] = useState(
    Array(feedbackTags.length).fill(false)
  );
  const [rating, setRating] = useState<number | undefined>();
  const [textFieldValue, setTextFieldValue] = useState("");
  const [submitted, setSubmitted] = useState(false);
  // const queryDetails = useSelector((state: RootState) => state.querySearchLog);
  const spinner = useSelector((state: RootState) => state.genAIWaiting);
  // const dispatch = useDispatch() as AppDispatch;

  useEffect(() => {
    setSubmitted(false);
    setRating(undefined);
    setSelectedTags(Array(feedbackTags.length).fill(false));
    setTextFieldValue("");
  }, [spinner]);

  const handleSubmitClick = () => {
    setSubmitted(true);
    console.log(rating)
    // const feedbackPayload = {
    //   queryId: queryDetails.queryId,
    //   sessionId: queryDetails.sessionId,
    //   rating: rating,
    //   isWrongInformation: selectedTags[0],
    //   isBadSource: selectedTags[1],
    //   isResponseIncomplete: selectedTags[2],
    //   isResponseSlow: selectedTags[3],
    //   isResponseTooLong: selectedTags[4],
    //   isResponseRelevant: false,
    //   comment: textFieldValue,
    // };
    // dispatch(logQueryFeedback({ feedback: feedbackPayload }));
  };
  const handleTagSelect = (index: number) => {
    const newSelectedTags = selectedTags;
    newSelectedTags[index] = !selectedTags[index];
    setSelectedTags(newSelectedTags);
  };
  return (
    <div className={spinner ? "" : styles.feedbackParent}>
      {!spinner ? (
        submitted ? (
          <div>Thank you for your feedback!</div>
        ) : (
          <div className={styles.feedbackForm}>
            <SmileyRating rating={setRating} />
            <FeedbackTags selectedBtns={handleTagSelect} />
            <AdditionalFeedback
              textFieldValue={textFieldValue}
              setTextFieldValue={setTextFieldValue}
            />
            <Button
              UNSAFE_className={styles.feedbackFormSubmit}
              onClick={handleSubmitClick}
              variant="primary"
            >
              Submit
            </Button>
          </div>
        )
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default Feedback;
